import { endOfDay, endOfMonth, format, min, startOfMonth } from "date-fns";
import isNil from "lodash-es/isNil";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import weui from "weui.js";
import { DateSelector } from "./dateSelector";

import icon from "../../assets/image/jine.png";
import zicon from "../../assets/image/z-sl.png";
import {
  MediaBox,
  MediaBoxInfo,
  MediaBoxTitle,
  Panel,
  PanelBody
} from "../../components/weui";
import { withMeterPicker } from "../../hooks/withMeterPicker";
import { commonService } from "../../services";
import { selectCurrentMeter } from "../../stores";
import {
  dateParam,
  formatUsage2,
  getAxiosError
} from "../../utils";

const BillInner = (props) => {
  const meter = useSelector(selectCurrentMeter);
  const name = meter ? `${meter.name}[${meter.meterClass}]` : "...";
  const infos = meter ? [meter.corpName, `|${meter.meterNo}`] : ["...", "|..."];
  const [date, setDate] = useState(new Date());
  const [usages, setUsages] = useState();

  const usageUnit = useMemo(() => meter?.meterClass === "电表" ? "度" : "吨", [meter?.meterClass]);

  const reload = useCallback(async () => {
    if (!meter) return;

    const loading = weui.loading("加载中");
    try {
      const s = startOfMonth(date);
      const e = min([endOfMonth(date), endOfDay(Date.now())]);
      const res = await commonService.getUsages(meter.meterNo, "D", dateParam(s), dateParam(e));
      setUsages(res.data);
    } catch (err) {
      weui.topTips(getAxiosError(err));
    } finally {
      loading.hide();
    }
  }, [meter, date, setUsages]);

  useEffect(() => {
    reload();
  }, [reload]);

  return (
    <>
      <Panel access onClick={ e => props.showMeterPicker() }>
        <PanelBody>
          <MediaBox text>
            <MediaBoxTitle>
              { name } <i className="iconfont icon-xiala ml-2"></i>
            </MediaBoxTitle>
            <MediaBoxInfo infos={ infos } />
          </MediaBox>
        </PanelBody>
      </Panel>

      <div className="bgSelf mt-6 py-4">
        <DateSelector onChange={ dt => setDate(dt) } />
      </div>

      { /* 水平分隔线 */ } 
      <div style={ { height: 1, backgroundColor: "var(--weui-BG-0)" } }></div>

      <div className="flex bgSelf textCor py-4">
        <div className="flex items-center w-1/2 justify-center">
          <img src={ zicon } alt="" className="w-9 h-9" />
          <div className="flex flex-col font-semibold ml-6">
            <span>总用数量</span>
            <span>{ isNil(usages?.totalUsage) ? "--" : formatUsage2(usages.totalUsage) } { usageUnit }</span>
          </div>
        </div>

        { /* 垂直分隔线 */ }
        <div className="-my-4" style={ { width: 1, backgroundColor: "var(--weui-BG-0)" } }></div>

        <div className="flex items-center w-1/2 justify-center">
          <img src={ icon } alt="" className="w-9 h-9" />
          <div className="flex flex-col font-semibold ml-6">
            { /*
            <span>总用金额</span>
            <span>{ isNil(usages?.totalMoney) ? "--" : formatCurrency(usages?.totalMoney) } 元</span>
            */ }
            <span>充值金额</span>
            <span>{ isNil(usages?.rechargeAmount) ? "--" : formatUsage2(usages?.rechargeAmount) } 元</span>
          </div>
        </div>
      </div>

      <div className="mt-6 flex justify-around py-4 subtext text-lg bgSelf">
        <div>抄表日期</div>
        <div>总用量</div>
      </div>

      <div className="h-96 overflow-hidden overflow-y-auto bgSelf">
        {
          usages && usages?.details.map((v, i) => {
            return (
              <div className="w-9/12 mAuto flex justify-between py-4 textCor"
                key={ i }>
                <div>{ format(new Date(v.chaoBiao), "MM月dd日HH时") }</div>
                <div>{ isNil(v.zongLiang) ? "--" : formatUsage2(v.zongLiang) } { usageUnit }</div>
              </div>
            );
          })
        }
      </div>
    </>
  );
};

export const Bill = withMeterPicker(BillInner);
